import { render, staticRenderFns } from "./withdrawTransferPol.vue?vue&type=template&id=5cf18a72&scoped=true"
import script from "./withdrawTransferPol.vue?vue&type=script&lang=js"
export * from "./withdrawTransferPol.vue?vue&type=script&lang=js"
import style0 from "./withdrawTransferPol.vue?vue&type=style&index=0&id=5cf18a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf18a72",
  null
  
)

export default component.exports